import React from 'react';
import { getResizedImageUrl } from '@lib/image';
import { IDesignerTestimonials } from '@components/pages/DesignerProfile/graphql/designer-profile-query.graphql';

import { DateTime } from 'luxon';
import styles from './Testimonial.module.scss';

const Testimonial = ({
  clientName,
  created,
  imageUrl,
  quote,
  roomType,
}: IDesignerTestimonials) => {
  const getDate = (date: string) => {
    return DateTime.fromISO(date).toFormat('MMMM y');
  };

  return (
    <div className={ styles.Root }>
      <div className={ styles.Thumb }>
        {
          !!imageUrl && (
            <img
              alt={ `${clientName}'s Happy Client` }
              src={getResizedImageUrl({ url: imageUrl, width: 400 })}
            />
          )
        }
      </div>
      <div className={styles.Text}>
        <p>{`"${quote}"`}</p>
        <span className={styles.RoomDate}>
          <b>{clientName || roomType}</b>, {getDate(created)}
        </span>
      </div>
    </div>
  );
};

export default Testimonial;
